module.exports = __webpack_public_path__ + "img/2.dd5091d9.png";